<!--

Component used to click and download an item. Generally a pdf document

 -->
<template>
  <div>
    <a :href="documentLink" class="text-light no-underline" >
      <div class="row justify-content-between box-style bg-primary">
        <div>
          {{documentName}}
        </div>
        <i class="material-icons">save_alt</i>
      </div>
    </a>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  data () {
    return {
      documentName: "",
      fileName: "",
      fileLocation: ""
    }
  },
  props: ['documentid'],
  mounted: function() {
    this.loadDocument()
  },
  computed: {
    documentLink: function() {
      return this.$helpers.staticDocs() + this.fileLocation + '/' + this.fileName
    }
  },
  methods: {
      loadDocument: function() {
      let local = this

      //make sure id is set before attempting to load
      if (this.documentid === 0) {
        return
      } 

      //ajax query
      axios({
          method: 'get',
          url: local.$helpers.api() + '/document/id/' + local.documentid,
          headers: {'X-Requested-With': 'XMLHttpRequest',
                    'Content-Type': 'application/json'}
        })
        .then(function (res) {
          local.documentName = res.data.title
          local.fileName = res.data.filename
          local.fileLocation = res.data.location
        })
        .catch(function (error) {
          console.log("error geting document data: ", error)
      });
    }
  }
}

</script>

<style scoped>

  .box-style {
    padding: 1em;
    cursor: pointer;
  }

  .box-style a {
    text-decoration: none;
  }      

  .box-style:hover {
    opacity: 0.8;
  }
</style>